module.exports = __webpack_public_path__ + "img/12加入我们-img4.30d0722d.jpg";